import React from "react";
import { useQuickSightItCompliance  } from "@/hooks/useItComplianceReports";

const QuickSightAwsItComplianceDashboard = () => {
  const { embedUrl } = useQuickSightItCompliance ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsItComplianceDashboard;
